import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initBillSlice,
  setPropertiesBill,
  updateBill,
} from "../Slices/Bill.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  roles,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import { http } from "../../../engine/api/http";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { BillHeader } from "../../../shared/components/BillHeader/BillHeader";

const { Content, Sider, Header, Footer } = Layout;

export function BillEdit({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const { bill, loading } = useSelector(state => state.bill);

  const { user } = useContext(UserContext);

  const { init, clear } = initBillSlice({});

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {} = bill;

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "Date document",
          name: "exportedDate",
          type: "date",
          showTime: false,
          allowClear: true,
          required: false,
          col: 24,
        },
        {
          label: "Commentaire facturation (privé)",
          name: "comment",
          type: "textarea",
          required: false,
          col: 24,
        },
        {
          label: "Commentaire facturation (pour l'institution)",
          name: "comment_institution",
          required: false,
          type: "textarea",
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    await dispatch(setPropertiesBill(data));
    dispatch(updateBill());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/bill", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: `Email envoyé avec succès`,
      });
  };

  return (
    <>
      <BillHeader
        title={routes.billing(id).detail.title + " " + bill.bill_number}
      />
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomForm
            disabled={
              !userHasLevel({
                only: {
                  [roles.admin]: "crud", //
                  [roles.permanance]: "crud", //
                },
              })
            }
            initialValues={bill}
            key={`bill-edit-${bill._id}-${bill.updatedAt || ""}-${bill.exportedDate || ""}`}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
